export default "<div style=\"height: 0; overflow: hidden;\">\n  <notifier-container></notifier-container>\n</div>\n\n<router-outlet></router-outlet>";